import { combineReducers } from "@reduxjs/toolkit";

// Front
import Layout from "./layout/layoutSlice";

// Authentication
import Register from "./auth/register/registerSlice";
import Login from "./auth/login/loginSlice";
import Account from "./auth/register/registerSlice";
import ForgetPassword from "./auth/forgetpwd/forgetpwdSlice";
import Profile from "./auth/profile/profileSlice";
import Player from "./slices/playerSlice";
import Club from "./slices/clubSlice";
import Annonce from "./slices/annonceSlice";
import Agent from "./slices/agentSlice";
import AgentAnnonce from "./slices/agentAnnonceSlice";
import AgentPlayer from "./slices/agentPlayerSlice";
import Application from "./slices/applicationSlice";
import Proof from "./slices/proofSlice";
import ProfileStatus from "./slices/profileStatusSlice";

//Calendar
import calendar from "./calendar/calendarSlice";

const rootReducer = combineReducers({
  // public
  Register,
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  calendar,
  Player,
  Club,
  Annonce,
  Agent,
  AgentAnnonce,
  AgentPlayer,
  Application,
  Proof,
  ProfileStatus
});

export default rootReducer;
